// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".creator_main__qjhbj,\n.creator_mainFullWidth__1CxU_ {\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 80px);\n  height: 100vh;\n  overflow: hidden;\n  background: #fafafa;\n  padding: 0; }\n\n.creator_mainFullWidth__1CxU_ {\n  width: 100%; }\n", ""]);
// Exports
exports.locals = {
	"main": "creator_main__qjhbj",
	"mainFullWidth": "creator_mainFullWidth__1CxU_"
};
module.exports = exports;
